











































































































































































































import Vue from "vue";
import ProgrammingTask from "@/components/ProgrammingTask.vue";
import store from "@/store/index";
import statusCodes from "@/config/status-codes";

export default Vue.extend({
  name: "Programming",
  components: {
    ProgrammingTask
  },
  data() {
    return {
      programmingTask: {
        number: 0,
        deadlineTs: 0,
        functionStart: {
          js: "",
          java: "",
          cpp: ""
        }
      },
      taskIds: [0, 1, 2, 3, 4], // todo get tasks amount from backend
      tick: null as any,
      savingLogs: null,
      isDangerRemaining: false,
      taskNumber: 0,
      lang: "js",
      userFunction: "",
      resultMessage: "",
      resultDialog: false,
      exitRequest: false,
      submitAnswerRequest: false,
      testLoading: false,
      submitLoading: false,
      finished: false,
      logs: []
    };
  },

  computed: {
    remaining(): number {
      this.isDangerRemaining = this.$store.state.programming.remainingTime < 10;
      return this.$store.state.programming.remainingTime;
    },
    deadline(): boolean {
      return this.$store.state.programming.remainingTime == 0;
    },
    programming(): any {
      return this.$store.state.programming;
    },
    loading(): boolean {
      return this.testLoading || this.submitLoading;
    }
  },

  watch: {
    async remaining() {
      if (this.deadline) {
        clearInterval(this.tick);
        await this.$store.dispatch("programming/finish");
        this.finished = true;
      }
    }
  },

  mounted() {
    this.programmingTask = this.programming.task;

    if (this.programmingTask) {
      this.taskNumber = this.programmingTask.number;
      this.userFunction = this.programmingTask.functionStart[this.lang];
      this.tick = setInterval(() => {
        this.$store.dispatch("programming/getRemainingTime");
      }, 60000);

      this.savingLogs = setInterval(() => {
        if (this.logs.length > 0) {
          this.$store.dispatch("programming/saveLogs", {
            taskNumber: this.taskNumber,
            logs: this.logs
          });
          this.logs = [];
        }
      }, 60000);
    }
  },

  async beforeRouteEnter(to, from, next) {
    try {
      Vue.set(store.state.programming, "loading", true);
      await store.dispatch("programming/getTask");
      await store.dispatch("programming/getRemainingTime");
      Vue.set(store.state.programming, "loading", false);

      next();
    } catch (e) {
      Vue.set(store.state.programming, "loading", false);

      if (e.code === statusCodes.NOT_ACTIVE_EXAM
        || e.code === statusCodes.NOT_ACTIVE_SESSION
        || e.code === statusCodes.CONCURRENT_EXAM) {
        next("/");
      } else {
        Vue.set(store.state.general, "exception", true);
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    clearInterval(this.tick);
    clearInterval(this.savingLogs);
    Vue.set(this.$store.state.general.examsList.programming, "finished", this.finished);
    Vue.set(this.$store.state.general.examsList.programming, "started", !this.finished);
    next();
  },

  methods: {
    async checkAnswer() {
      this.testLoading = true;

      try {
        await this.$store.dispatch("programming/saveAnswer", {
          action: "test",
          taskNumber: this.taskNumber,
          lang: this.lang,
          userFunction: this.userFunction
        });

        if (this.programming.error) {
          this.resultMessage = this.programming.message;
        } else {
          this.resultMessage = this.getResultMessage();
        }

        this.resultDialog = true;
      } catch (e) {
        Vue.set(this.$store.state.general, "exception", true);
      }

      this.testLoading = false;
    },

    async submitAnswer() {
      this.submitAnswerRequest = false;
      this.submitLoading = true;

      try {
        if (this.logs.length > 0) {
          await this.$store.dispatch("programming/saveLogs", {
            taskNumber: this.taskNumber,
            logs: this.logs
          });
          this.logs = [];
        }

        await this.$store.dispatch("programming/saveAnswer", {
          action: "submit",
          taskNumber: this.taskNumber,
          lang: this.lang,
          userFunction: this.userFunction
        });

        if (this.programming.error) {
          this.resultMessage = this.programming.message;
          this.resultDialog = true;
        } else {
          if (this.programming.finished) {
            this.finished = true;
            this.exit();
            return;
          }

          await this.$store.dispatch("programming/getTask");
          this.programmingTask = this.programming.task;
          this.taskNumber = this.programmingTask.number;
          this.logs.push({
            timestamp: Date.now(),
            lang: this.lang,
            taskNumber: this.taskNumber,
            event: "taskOpened",
            input: ""
          });
        }
      } catch (e) {
        Vue.set(this.$store.state.general, "exception", true);
      }

      this.submitLoading = false;
    },

    async checkSubmitAnswerRequest() {
      if (this.taskNumber === 0) {
        await this.submitAnswer();
      } else {
        this.submitAnswerRequest = true;
      }
    },

    async finishTest() {
      try {
        await this.$store.dispatch("programming/finish");
        this.finished = true;
        this.exit();
      } catch (e) {
        Vue.set(this.$store.state.general, "exception", true);
      }
    },

    saveFunction(data) {
      this.taskNumber = data.taskNumber;
      this.lang = data.lang;
      this.userFunction = data.userFunction;
    },

    handleUserAction(data) {
      this.logs.push({
        timestamp: data.timestamp,
        lang: data.lang,
        taskNumber: data.taskNumber,
        event: data.event,
        input: data.input || ""
      });
    },

    getResultMessage(): string {
      let passedCount = 0;

      this.programming.resultCases.forEach((passed) => {
        if (passed) {
          passedCount++;
        }
      });

      return this.$t("programming.testResult", {
        passed: passedCount,
        all: this.programming.resultCases.length
      }).toString();
    },

    exit() {
      this.$router.push({name: "home"});
    }
  }

});
